<template>
  <section>
    <NewsHeader />
    <NewsSearch />
    <NewsIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'News',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['news-index'] || {}
    }
  }
}
</script>
